import { DialogContent, SxProps, Theme, styled } from '@mui/material'
import { FC, PropsWithChildren } from 'react'

interface ModalBodyProps {
  sx?: SxProps<Theme>
}

const ModalBody: FC<PropsWithChildren<ModalBodyProps>> = ({ children, sx }) => (
  <StyledDialogContent sx={sx}>{children}</StyledDialogContent>
)

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  background-color: 'white';
`

export default ModalBody
